module.exports = __webpack_public_path__ + "static/media/eComicSR-01_2x.35b0f382.png";